import type { MessageType } from 'common/enums/Alert';

export class ReclamationError extends Error {
  type?: MessageType;

  constructor({ message, type }: { message?: string; type: MessageType }) {
    super(message);
    // Setting the prototype manually, so we're able to use instanceof.
    // This is recommended approach by TypeScript for extending built-in classes:
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, ReclamationError.prototype);

    this.type = type;
  }
}
